import { AxiosPromise } from 'axios';
import api from './api';

// eslint-disable-next-line import/prefer-default-export
export function getCurrentTodo() {
  return new Promise<AxiosPromise>((resolve, reject) => {
    try {
      api.get('/to-do/current')
        .then((response: any) => {
          resolve(response);
        })
        .catch((e: Error) => {
          reject(e);
        });
    } catch (e) {
      reject(e);
    }
  });
}
